import { defineMessages } from 'react-intl';

export const reorderConflictModalMessages = defineMessages({
  modalA11yLabel: {
    defaultMessage: 'Review conflicts modal',
    description: 'Reorder | Conflict review modal | a11y label',
  },
});
